<span class="loader"
[style.--width1]=" width+ 'px'"
[style.--width2]=" (width * 0.6666)+ 'px'"
[style.--thickness]=" thickness+ 'px'"
[style.--primaryColor]="primaryColor "
[style.--secondaryColor]="secondaryColor "></span>